import * as React from 'react';

import './MessageView.css';

import IMessage from '../../Models/Message/IMessage';
import { getPrettyTime } from '../../Util/dateFormatter';

interface IMessageProps {
    message: IMessage,
}

const Message: React.SFC<IMessageProps> = (props) => {

    let username = props.message.user;
    let userLinkName = props.message.userLinkName ? props.message.userLinkName : props.message.user;

    // In some rare case we may the user as a user object, in which case we should treat it as such.
    if (typeof props.message.user == "object") {
        username = props.message.user.username ? props.message.user.username : props.message.user;
        userLinkName = props.message.user.userLinkName ? props.message.user.userLinkName : props.message.user._userLinkName;
    }

    const link = "/profile/" + userLinkName;

    return (
        <li>
            <span className="message-user">
                <a href={link} target="_blank">
                    {username}
                </a>
            </span>
            <span className="message-timestamp">({getPrettyTime(props.message.timestamp)}): </span>
            {props.message.content}
        </li>
    )
}

export default Message;